import { IconProps } from "./types";

const CaretDown = ({ color = "#100069", ...props }: IconProps) => {
  return (
    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" {...props}>
      <path
        d="M1 1L4.98438 5.21875L8.96875 1"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CaretDown;
